import styled from '@emotion/styled';
import { Button } from 'src/ui/components/button/common/Button';
import { withConfig } from 'src/withConfig';

export const GridBodyWrapper = withConfig(theme => styled('div', { label: 'GridBodyWrapper' })`
    align-content: start;
    display: grid;
    flex: 1 1 auto;
    gap: 8px;
    grid-template-columns: repeat(2, 1fr);
    grid-auto-rows: min-content;
    height: calc(100% - 40px);
    overflow: auto;
    padding: 0 8px 56px;
    scrollbar-color: ${theme.star.scrollableLinksHeader.bgColorSecondary} ${theme.star.scrollableLinksHeader.bgColor};
    scrollbar-width: thin;
    &::-webkit-scrollbar {
        width: 1px;
        background-color: ${theme.star.scrollableLinksHeader.bgColor};
    }
    &::-webkit-scrollbar-thumb {
        background-color: ${theme.star.scrollableLinksHeader.bgColorSecondary};
        border-radius: 10px;
    }
    @media ${theme.star.mediaQuery.desktop} {
        gap: 4px;
        max-height: 425px;
        padding: 0 0 8px;
    }
`);

export const MiniGamesButton = withConfig(theme => styled(Button, { label: 'MiniGamesButton' })`
    @media ${theme.star.mediaQuery.desktop} {
        padding: 0 8px;
    }
`);
